export const VESTIGAS_SUPPORT_CONTACT = {
  phone: '+49 89 904215125',
  email: 'support@vestigas.com',
} as const;
